import React, { useEffect, useLayoutEffect, useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import SettingsTab from './SettingsTab';
import ProfileTab from './ProfileTab';
import { useDispatch, useSelector } from 'react-redux';
import { selectUserProfile, setSidebar } from '../userSlice';
import UserProfileHeader from './UserProfileHeader';

const UserSettings = () => {
  const { empCode } = useParams();
  const [value, setValue] = useState('settings');
  const user = useSelector(selectUserProfile);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useLayoutEffect(() => {
    if (!user) {
      dispatch(setSidebar({ value: false }));
      navigate('/admin/user');
    }
  }, [user, dispatch]);

  return (
    <Box sx={{ width: '100%', typography: 'body1', overflow: 'none' }}>
      {user && <UserProfileHeader user={user} />}
      <Tabs value={value} onChange={handleChange} aria-label="User settings tabs">
        <Tab label="Settings" value="settings" />
        <Tab label="Profile" value="profile" />
      </Tabs>
      {value === 'settings' && <SettingsTab empCode={empCode} />}
      {value === 'profile' && <ProfileTab />}
    </Box>
  );
};

export default UserSettings;
